import React from 'react'
import { graphql } from 'gatsby'
import Section from '../components/Section'
import Layout from '../components/PageLayout'
import CardDistance from '../components/CardDistance';
import CardTime from '../components/CardTime';
import moment from "moment";
import CardActivities from '../components/CardActivities';
import CardElevation from '../components/CardElevation';
import CardMembers from '../components/CardMembers';

export default ({data}) => {
  
  const elevation = data.lastWeek.edges[0].node.elevationm
  const activities = data.lastWeek.edges[0].node.nombredactivites
  console.log(data.lastWeek.edges[0].node.tempshhmmss.split(':'))
  //const minutes = moment.duration(data.lastWeek.edges[0].node.tempshhmmss).asMinutes()
  const milliseconds = moment.duration(data.lastWeek.edges[0].node.tempshhmmss).asMilliseconds()
  console.log('minutes : ', milliseconds)
  const km = data.lastWeek.edges[0].node.strdistance.replace(',', '.').replace("_", "");
  console.log("km : ", km)
  const totalMembers = data.allMembers.totalCount
  
  return (
    <Layout>
      <Section
        title='La Semaine dernière' 
        id="lastweek" 
        color='background'
      >
        <CardMembers members={totalMembers} />
        <CardActivities activities={activities} />
        <CardDistance distance={km} />
        <CardTime time={milliseconds} />
        <CardElevation elevation={elevation} />
      </Section>
    </Layout>
  )
}


export const query = graphql`
  query lastWeekQuery {
    lastWeek: allGoogleSheetStatsRow(limit: 1, sort: {fields: semaine, order: DESC}) {
      edges {
        node {
          id
          nombredactivites
          semaine
          distancekm
          tempshhmmss
          elevationm
          strdistance
          membres
        }
      }
    }

    allMembers: allStravaClubMember {
      totalCount
    }
  }
`
